import {ThemeType} from '../../../theme';
import {BaseLayoutHoverProps, LayoutProps} from '../types';
import {getExcitedColor} from './getExcitedColor';

export const getExcitedPropVariants = (
  theme: ThemeType,
  props: LayoutProps,
): BaseLayoutHoverProps => ({
  backgroundColor: getExcitedColor(theme, props.backgroundColor),
});
